// const app
export const KEY_TOKEN = "AccessToken";
export type RolesAdmin = "admin" | "agency";
export const KEY_INFO_USER = "InfoUser";
